import React from "react";
import { Grid, MenuItem } from "@material-ui/core";
import { Formik } from "formik";
import SelectDropOtions from "../../../../components/SelectDropOtions";
// import { useStyleFormAssignRoom } from "../../assign_build/helpers/AssignBuildEvtOption";

const FilterData = ({
    onSubmit = () => {},
    initialFormValues = {},
    isCreateForm = true,
    buildingOption = [],
    floorOption = [],
    handleSelectFloor = () => {},
    handleSelectBuilding = () => {},
    handleCancel = () => {},
}) => {
    // const classes = useStyleFormAssignRoom();

    return (
        <Formik initialValues={initialFormValues} onSubmit={onSubmit}>
            {({ setFieldValue, values, errors }) => (
                <Grid container spacing={1}>
                    <Grid item xs={12} lg={2}>
                        <SelectDropOtions
                            //containerClass={`${classes.border} ${classes.select}`}
                            options={buildingOption}
                            placeholder="Select Build..."
                            value={values?.buildingId}
                            onChange={val => handleSelectBuilding(val, setFieldValue)}
                            error={Boolean(errors?.buildingId)}
                            helperText={errors?.buildingId}
                            useTheme={true}
                            renderOption={row => (
                                <MenuItem value={row?.buildingId} key={row?.buildingId + "_b"}>
                                    {row?.name}
                                </MenuItem>
                            )}
                        />
                    </Grid>
                    <Grid item xs={12} lg={5}>
                        <Grid container spacing={1}>
                            <Grid item xs={12} lg={6}>
                                <SelectDropOtions
                                    //containerClass={`${classes.border} ${classes.select}`}
                                    options={floorOption?.filter(item => item?.buildingId === values?.buildingId)}
                                    placeholder="Select Floor..."
                                    value={values?.floorId}
                                    onChange={val => handleSelectFloor(val, setFieldValue)}
                                    error={Boolean(errors?.floorId)}
                                    helperText={errors?.floorId}
                                    useTheme={true}
                                    renderOption={row => (
                                        <MenuItem value={row?.floorId} key={row?.floorId + "_b"}>
                                            {row?.name} {row?.locationName}
                                        </MenuItem>
                                    )}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            )}
        </Formik>
    );
};

export default FilterData;
